
import React from "react";
import recruit22_logo from "../../../static/img/recruit22.png";
import "./style.css";

export const Recruit = ({
    className,
    recruitClassName,
}) => {
    return (
        <div className={`recruit ${className}`}>
            <img
                className={`img ${recruitClassName}`}
                alt="Recruit"
                src={recruit22_logo}
            />
        </div>
    );
};

